/**
 * @description
 * Ranking image resource reference
 */
var jerseys = {
    'BLU' : 'Blue.png',
    'WHT' : 'White.png',
    'RW' :'Red_And_White.png',
    'RED' : 'Red.png',
    'BLK' : 'Black.png',
    'YLW' : 'Orange.png',
    'BW' : 'Black_And_White.png',
    'GRN' : 'Green.png'
}

module.exports = {
  drawRankingTable: function (ranking) {
     var tableBody = $('#ranking-table-body');
    tableBody.empty();
    tableBody.append(rankingTableHeaderHtml());
    $.each(ranking, function( index, value ) {
        tableBody.append(rankingTableRowHtml(value))
    });
  }
};

var translation = window['langArr'][window['language']];

function rankingTableRowHtml(rowData) {
    var html = '<div class="standings-table-row">';
    html += '<ul>';
    html += '<li class="sth-sm">'+rowData.Position+'.</li>';
    html += '<li class="sth-md"> <img src="./img/jerseys/'+jerseys[rowData.Kit_Home]+'" alt="table-jersey" width="22" height="18" /> '+rowData.Code+' </li>';
    html += '<li class="sth-sm">'+rowData.Points+'</li>';
    html += '<li class="sth-xs">'+rowData.Wins+'</li>';
    html += '<li class="sth-xs">'+rowData.Draws+'</li>';
    html += '<li class="sth-xs">'+rowData.Losses+'</li>';
    html += '<li class="sth-lg">';
    for (var i = 0; i < rowData.History.length; i++) {
        formLetter = rowData.History.charAt(i);
        html += '<div class="str-form str-form-'+formLetter.toLowerCase()+'">'+ translation[formLetter.toLowerCase()]+'</div>';
    }
    html += '</li>';
    html += '</ul>';
    html += '</div>';
    return html;
}

function rankingTableHeaderHtml() {
    var html = '<div class="standings-table-header">';
    html += '<ul>';
    html += '<li class="sth-sm">' + translation.pos + '</li>';
    html += '<li class="sth-md">' + translation.team + '</li>';
    html += '<li class="sth-sm">' + translation.pts + '</li>';
    html += '<li class="sth-xs">' + translation.w + '</li>';
    html += '<li class="sth-xs">' + translation.d + '</li>';
    html += '<li class="sth-xs">' + translation.l + '</li>';
    html += '<li class="sth-lg">' + translation.FORM + '</li>';
    html += ' </ul>';
    html += '</div>';

    return html;
}



//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football-league/js/modules/table/table.js
// module id = 2001
// module chunks = 4